import React from 'react';
import { 
    Dialog,
    IconButton,
    Typography,
    DialogTitle,
    Button,
    DialogContent
} from "@material-ui/core/";
import TagManager from 'react-gtm-module';
import arquivo from "../assets/Aviso de privacidade TokStok.pdf" 
import CloseIcon from '@material-ui/icons/Close';

//css
import Styles from './styles';
const useStyles = Styles();

export default(params)=>{
    const classes = useStyles();

    function HeaderModal() {
        return(
            <div className={classes.headerModal}>
                <IconButton aria-label="close" onClick={params.handleDialogModalPoliticaPrivacidade} className={classes.closeButton} >
                    <CloseIcon />
                </IconButton>
                <Typography variant="h6" align="center">
                    {"Aviso de Privacidade"}
                </Typography>
            </div>
        )
    }

    function DownloadFile() {
        TagManager.dataLayer({
            dataLayer: {
              event: 'event',
              eventCategory: 'tokstok:fornecedores:login',
              eventAction: 'clique:botao',
              eventLabel: 'baixar-aviso-de-publicidade',
            }
        });
    }

    function ButtonConfirm(params) {
        return (
            <div className={classes.footerSpace} align="center">
                <Button onClick={DownloadFile} type="submit" variant="contained" color="primary" href={arquivo} download="Aviso de privacidade TokStok.pdf">
                    <i className="material-icons">
                        file_download
                    </i> 
                    {" Baixar Aviso de Privacidade"}
                </Button>
            </div>
        )
    }

    return (
        <div>
            <Dialog
                open={params.state.openPoliticaPrivacidade}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth = {"md"}
            >
                <DialogTitle>
                    <HeaderModal {...params}/>
                </DialogTitle>
                <object width="100%" className={classes.pdfView} type="application/pdf" data={arquivo+"#view=Fith&toolbar=0&navpanes=0"}>
                    <Typography variant="h6" align="center" >O documento não pode ser visualizado neste dispositivo.</Typography>
                </object>
                <Typography style={{ padding: "10px"}} align="center">
                    <ButtonConfirm {...params}/>
                </Typography>

            </Dialog>
        </div>
    );
}
